import { useCallback, useEffect } from 'react';
import { useChannelsStore } from '../stores/channels.store';
import { ChannelFilters } from '../../shared/types/ChannelFilters';

export const useChannels = (opts: { loadOnMount?: boolean; page?: number; perPage?: number; filters?: ChannelFilters } = {}) => {
  const { loadOnMount = true, page = 1, perPage = 10, filters } = opts;
  const { channels, pagination, isLoading, error, list, listAll, countFor, setFilters } = useChannelsStore();

  useEffect(() => { if (loadOnMount) { list(page, perPage, filters); } }, [loadOnMount, list, page, perPage, filters]);

  const refresh = useCallback(
    (p: number, pp: number, f?: ChannelFilters, append?: boolean) => list(p, pp, f, append),
    [list],
  );
  const fetchAll = useCallback((f?: ChannelFilters) => listAll(f), [listAll]);
  const countChannels = useCallback((f: ChannelFilters) => countFor(f), [countFor]);

  return { channels, pagination, isLoading, error, refresh, fetchAll, countChannels, setFilters };
};
